import 'bootstrap/js/src/tab';
import * as $ from 'jquery';
export default (
    function()
    {
        $('.nav-tabs a').each(function() {
            var $tab = $(this);
            $tab.on('click', function(e) {
                e.preventDefault();
                $(this).tab('show');
            });
        });
    }($)
);